import BaseAPI from './base.api.service'

const resource = 'users';
export default {
    async getUserRoles() {
        return await BaseAPI.get(`${resource}/roles`);
    },
    async getUsers() {
        return await BaseAPI.get(`${resource}`);
    },
    async getUser(id) {
        if (id) {
            return await BaseAPI.get(`${resource}/${id}`);
        }
        else {
            return await BaseAPI.get(`${resource}/me`)
        }
    }
} 